import axios from "axios";
import LazyLoadImage from "../classes/lazyloadimage";

export default class Group {
    constructor() {
        if(document.getElementsByClassName('group-page')[0]) {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

            const url = new URL(window.location.href);
            this.endpoint = url.pathname;
            // this.loadMoreButton = document.querySelector('#load-more-button');
            this.hasMore = window['HAS_MORE'];
            this.loading = false;
            this.ikeLoader = document.getElementById('ike-loader');
            this.dataWrapper = document.getElementById('data-wrapper');
            this.lazyLoading = new LazyLoadImage();

            this.page = 1;
            window.addEventListener('scroll',() => {
                if (!this.loader && this.hasMore) {
                    if(window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - document.querySelector('footer').offsetHeight - document.querySelector('.publish-event-section').offsetHeight) {
                        this.loader = setTimeout(() => {
                            this.page++;
                            this.updateData();
                        }, 100);
                    }
                }
            });
        }
    }

    updateData() {
        this.dataWrapper.classList.remove('got-result');
        this.ikeLoader.style.display = 'block';
        axios.get(`${this.endpoint}?page=${this.page}`)
            .then((response) => {
                // handle success
                this.hasMore = response.data.has_more;

                if(!window.matchMedia('(max-width: 800px)').matches) {
                    this.dataWrapper.style.display = 'flex';
                }
                else {
                    this.dataWrapper.style.display = '';
                    this.dataWrapper.classList.add('got-result');
                }
                this.ikeLoader.style.display = 'none';

                this.dataWrapper.innerHTML = this.dataWrapper.innerHTML + response.data.html;
                this.lazyLoading.lazyLoading();

                if (document.getElementsByClassName('search-no-result')[0]) {
                    const resetButton = document.getElementById('reset-all-button');
                    resetButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        document.getElementsByClassName('search-input')[0].value = '';
                    }, {once: true});
                }
            })
            .catch((error) => {
                // handle error
                console.log(error);
            })
            .finally(() => {
                this.loader = false;
            });
    }
}
